module.exports = __webpack_public_path__ + "static/media/img_molecule.c96eec68.jpg";